export default {
  props: {
    pollId: {
      type: [Number, String],
      default: null
    },
    question: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    input_type: {
      type: Object,
      default: null
    },
    output_type: {
      type: String,
      default: null
    },
    condition: {
      type: [Object, Array],
      default: null
    },
    dependent: {
      type: Array,
      default: null
    },
    styles: {
      type: Object,
      default: () => null
    },
    description: {
      type: String,
      default: ''
    }
  }
};
